import { render } from "./ProfileContragent.vue?vue&type=template&id=5348ce38"
import script from "./ProfileContragent.vue?vue&type=script&lang=js"
export * from "./ProfileContragent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__